import { IStepForm } from 'src/types'

export const initialFormState = (code: string): IStepForm => ({
  name: '',
  description: '',
  code,
  image: {
    icon: '',
    file: null,
  },
  image_small: null,
  image_medium: null,
  media: [],
  selectedImpacts: [],
  selectedAccount: null,
  selectedScanners: [],
  locations: [
    {
      location_name: '',
      location_address: '',
      latitude: 0,
      longitude: 0,
      radius: 50,
    },
  ],
})
